require('./style.less');

var TextLayerView = require('../view');


module.exports = TextLayerView.extend({

    onRender: function() {

        this.updateTransform();
        TextLayerView.prototype.onRender.apply( this, arguments );

    },

    /* Note: needs update on rotation because of the scale factor between the original and derived dimensions */
    rotate: function() {

        if ( this.page.get('rotation') !== this.page.previous('rotation') )
            this.updateTransform();
    },

    updateTransform: function() {

        var dmRatio = this._getDocModeRatio();

        this.$el.css({
            transform: 'scale(' + dmRatio + ')'
        });

    },

    // TODO: belongs on model  -- needs to scale to match difference in 'derived' vs original dimensions ( in pixels )
    // This could also apply to other layers
    _getDocModeRatio: function() {

        var originalDimensions = this.page.originalDimensions();
        var derivedDimensions = this.page.getDimensions();

        var r = this.page.get('rotation');

        var dmRatio = ( r === 0 || r === 180 )
            ? derivedDimensions.width / originalDimensions.w
            : derivedDimensions.height / originalDimensions.h;

        return dmRatio;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/textLayer/docMode/view.js
 ** module id = 450
 ** module chunks = 0
 **/